import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  padding: 24px;
  line-height: 1.6;
`;

const Italic = styled.i``;

const Bold = styled.b``;

const Avangarda = () => {
  return (
    <Wrapper>
      <b>Hronologija avangarde</b>
      <br />
      <br />
      <div>1921.</div>- U februaru počinje da izlazi časopis <em>Zenit</em> –
      Internacionalna revija za umetnost i kulturu. Urednik Ljubomir Micić. U
      prvom broju časopisa <em>Zenit</em> izlazi <em>Zenitistički manifest</em>{" "}
      Ivana Golla pisan na nemačkom i <em>Manifest zenitizma</em> čiji su
      potpisnici Ljubomir Micić, Ivan Goll i Boško Tokin. <em>Zenit</em>{" "}
      uspostavlja aktivnu saradnju sa Arhipenkom osnivačem umetničke škole u
      Berlinu. <br />- Branko Ve Poljsnski i Dragan Aleksić u Pragu priređuju
      zenitističke i dadaističke manifestacije. Osnovan umetnički klub{" "}
      <em>Zenit</em>. <br />- Zenitovi saradnici u prvoj polovini godine
      objavljuju značajna dela: Rastko Petrović{" "}
      <em>Bruleska gospodina Peruna boga groma</em>, Miloš Crnjanski{" "}
      <em>Dnevnik o Čarnojeviću</em>, Stanislav Vinaver{" "}
      <em>Gromobran Svemira</em>, Miroslav Krleža{" "}
      <em>Marginalije uz slike Petra Dobrovića</em>. Izlazi revija za filmsku
      kulturu <em>Kinofon</em>, urednik Valerij Poljanski
      <br />
      <br />
      <div>1922.</div>- Časopis <em>Putevi</em> izlazi u Beogradu, a urednici i
      saradnici su: Milan Dedinac, Dušan Timotijević, Marko Ristić, Miloš
      Crnjanski, Rastko Petrović, Stanislav Vinaver, Dušan Matić, Todor
      Manojlović, Boško Tokin, Aleksandar Vučo i drugi. <br />- Rastko Petrović
      objavljuje knjigu <em>Otkrovenje</em>. Dragan Aleksić izdaje u Zagrebu
      dadaističke revije <em>Dada tank</em> i <em>Dada jazz</em>, a Branko Ve
      Poljanski <em>Dada-jok</em>. <br />- Rade Drainac pokreće časopis{" "}
      <em>Hipnos</em> u kome, između ostalih, sarađuju Moni de Buli i Rastko
      Petrović. <br />- Časopis novosadskih aktivista <em>Ut</em> pokreće Zoltan
      Čuka. U njemu Mihailo S. Petrov štampa svoje gravire. <br />- Ilija
      Erenburg i El Lisicki priredili <em>Zenit</em> br. 17/18 koji je bio
      posvećen novoj ruskoj umetnosti. El Lisicki uradio naslovnu stranu{" "}
      <em>Zenita</em>.<br />
      <br />
      <div>1923.</div>- Održan je performans <em>Hiljadu druga noć</em> u
      beogradskoj Kasini. Dizajn plakata potpisuje Dušan Janković, a za
      futuristički balet <em>Služiteljeva metla</em>, tekst i muziku pišu Marko
      Ristić i Miloje Milojević, dok koreografiju radi Klavdije Isačenko. <br />
      - Ljubomir Micić objavljuje manifest{" "}
      <em>Zenitizam kao balkanski totalizator novog života</em> u svom časopisu{" "}
      <em>Zenit</em> i organizuje prve zenitističke večeri u Beogradu i Zagrebu.{" "}
      <br />
      Slobodan Mišić Paležanski uređuje šabački avangardni časopis{" "}
      <em>Venturaementes</em> (Duhovi koji dolaze), od koga je izašao jedan
      broj. <br />- Dragan Aleksić objevljuje tekst{" "}
      <em>Konstruktivističko slikarstvo</em>. <br />- Ljubomir Micić prenosi
      uredništvo <em>Zenita</em> iz Zagreba u Beograd. <br />- Poljanski u
      Beogradu održao predavanje o zenitizmu i novoj umetnosti. <br />
      <br />
      <br />
      <div>1924.</div>- Časopis <em>Svedočanstva</em>, objavljivan je u Beogradu
      do 1925. godine, a urednici i saradnici su bili: Milan Dedinac, Mladen
      Dimitrijević, Dušan Matić, Rastko Petrović, Marko Ristić, Aleksandar Vučo
      i drugi. Ilustracije su: crtež Pabla Pikasa, crteži umobolnih i
      fotografije tatuaža. <br />- Moni de Buli izdaje almanah{" "}
      <em>Crno na belo</em>, Branko Kovačević <em>Almanah Branka Radičevića</em>{" "}
      sa fotografijama, a Dušan Jerković i Desimir Blagojević časopis{" "}
      <em>Umetnost</em>.<br />- U Beogradu se održava{" "}
      <em>Prva Zenitova međunarodna izložba nove umetnosti</em>.
      <br />- Ivan Goll saurednik <em>Zenita</em> pokreće časopis{" "}
      <em>Surrealisme</em> u Parizu. <br />
      <br />
      <div>1925.</div>- Marko Ristić objavljuje <em>Od sreće i od sna</em>,
      knjigu poezije, a Moni de Buli <em>Textes surréalistes</em> u pariskom
      časopisu <em>La Révolution surréaliste</em> (no. 5). <br />- Moni de Buli
      i Dušan Matić su među potpisnicima nadrealističke deklaracije{" "}
      <em>La révolution d’abord et toujours</em> objavljene u pariskom listu{" "}
      <em>Clarté</em>.<br />- Pokreću se novi časopisi: <em>Okno</em>, urednik
      Đorđe Jovanović, <em>Bela revija</em>, urednici Risto Ratković i B.
      Jovanović, <em>Film</em>, urednici Maksim Goranović i Boško Tokin, almanah{" "}
      <em>Čaša vode</em>, urednik Risto Ratković. Ljubomir Micić objavljuje
      poemu <em>Aeroplan bez motora</em>. <br />
      <br />
      <div>1926.</div>- Oko časopisa <em>Večnost</em> okupljaju se Risto
      Ratković, Moni de Buli, Dragan Aleksić, Dušan Jerković, Desimir Blagojević
      i drugi mladi pesnici. <br />
      - Nikola Vučo u Parizu, a Vane Živadinović Bor u Vrnjačkoj Banji snimaju
      prve serije nadrealistickih fotografija. <br />- Marko Ristić upoznaje
      Bretona i francuske nadrealiste za vreme boravka u Parizu i počinje da
      radi na ciklusu kolaža <em>La vie mobile</em>. <br />- Milan Dedinac
      štampa <em>Javnu pticu</em>, poemu sa fotomontažama. Knjige pesama
      objavljuju: Aleksandar Vučo <em>Krov nad prozorom</em>, Moni de Buli{" "}
      <em>Krilato zlato</em>, Branko Ve Poljanski <em>Tumbe</em>. Osnovana
      umetnička je grupa <em>Oblik</em> u Beogradu. <br />- Zabranjeno je
      izdavanje časopisa <em>Zenit</em> Ljubomira Micića koji je izlazio u
      Zagrebu i Beogradu od 1921. godine. <br />- Jugoslovenski zenitizam
      predstavljen na <em>Izložbi revolucionarne umetnosti</em> u Moskvi. <br />
      - Časopis <em>Zenit</em> zabranila Uprava grada Beograda, a Apelacioni sud
      podigao optužbu “da se inkriminisanim izrazima širi komunistička
      propaganda i posredno pozivaju građani da silom, putem revolucije, menjaju
      postojeći društveni poredak ugledajući se na rusku revoluciju” <br />
      <br />
      <div>1927.</div>- Marko i Ševa Ristić donose iz Pariza sliku Maksa Ernsta{" "}
      <em>Sova (Ptica u kavezu)</em> u Beograd (Legata Marka Ristića u Muzeju
      savremene umetnosti u Beogradu).
      <br />- Moni de Buli objavljuje <em>Antenu smrti</em> i <em>Leviatana</em>
      , zbirku poezije sa Ristom Ratkovićem, Rastko Petrović roman{" "}
      <em>Sa silama nemirljivim</em>, a Stanislav Vinaver{" "}
      <em>Ženidbu Vrapca Podunavca</em>, poemu. <br />- U almanahu{" "}
      <em>Novi istok</em> saradjuju Moni de Buli, Risto Ratković i drugi.
      <br />
      <br />
      <div>1928.</div>- Aleksandar Vučo objavio roman <em>Koren vida</em>, a
      Marko Ristić antiroman <em>Bez mere</em>. Đorđe Kostić, Oskar Davičo i
      Đorđe Jovanović pokreću časopis <em>Tragovi</em>, a Zvezdan Vujadinović{" "}
      <em>50 u Evropi</em>, koji izlazi do 1933. godine, a u njemu saradjuju
      Slobodan Kusić, Branko Milovanović, Dragan Aleksić i drugi. <br />
      - Vane Bor ulazi u krug francuskih nadrealista, i podstaknut Ernstovim
      delom eksperimentiše sa neslikarskim materijalima. Vane Bor i Marko Ristić
      počinju istraživanja u tehnici fotograma. <br />- Rastko Petrović putuje u
      Afriku, gde pravi seriju crteža i fotografija i piše putopis{" "}
      <em>Afrika</em> (1930). <br />- Oto Bihalji Merin i Pavle Bihali izdaju
      časopis <em>Nova literatura</em> i osnivaju Nolit.
      <br />
      <br />
      <div>1929.</div>
      - Đorđe Kostić, Đorđe Jovanović, Oskar Davičo i Dušan Matić rade na
      okupljanju beogradske grupe nadrealista. <br />
      - Nikola Vučo, pravi novu seriju fotografija u Parizu i Beogradu koje će
      pokloniti Muzeju primenjene umetnosti u Beogradu 1990. godine. <br />-
      Andre Tirion (André Thirion), francuski nadrealista, gostuje u kući Lule i
      Aleksandra Vuča kada nastaje serija <em>Le cadavre exquis</em>. <br />
      -U Beogradu boravi, u poseti kod nadrealista i Andre Žermen (André
      Germain), urednik časopisa <em>La revue européene</em>.<br />
      -Knjigu poezije objavio je Aleksandar Vučo,{" "}
      <em>Ako se još jednom setim ili načelo</em> a Đorđe Jovanović sa Đorđem
      Kostićem i Oskarom Davičom plakat <em>Četiri strane</em> itd. Koča Popović
      i Vane Bor zajedno sa francuskim umetnicima potpisuju protest{" "}
      <em>Čovek od ukusa</em> u pariskom časopisu <em>Revue Du Cinéma</em> (br.
      3), a Moni de Buli prilazi grupi <em>Le Grand Jeu</em> (Velika igra), a
      zajedno sa Didom de Majom i drugim pesnicima pokreće u Parizu časopis{" "}
      <em>Discontinuité</em>, od koga je izašao samo jedan broj.
      <br />
      <br />
      <div>1930.</div>- Almanah <em>Nemoguće-Læimpossible</em> izlazi u Beogradu
      sa manifestom nadrealizma koji su potpisala trinaestorica članova grupe:
      Aleksandar Vučo, Oskar Davičo, Milan Dedinac, Mladen Dimitrijević, Vane
      Živadinović Bor, Radojica Živanović Noe, Đorđe Jovanović, Đorđe Kostić,
      Dušan Matić, Branko Milovanović, Koča Popović, Petar Popović i Marko
      Ristić. Osim beogradske grupe nadrealista u almanahu saradjuju: Breton,
      Elijar (Eluard), Pere (Peret), Aragon (Aragon), Sar (Char) i Tirion
      (Thirion). <br />- Prvi broj časopisa francuskih nadrealista{" "}
      <em>La surréalisme au service de la révolution</em> donosi tekst posvećen
      osnivanju beogradske grupe i njenom manifestu. <br />- Žan-Pol Drajfus
      (Jean-Paul Drenjfus) posvećuje Vanu Boru kritiku o filmu Frica Langa
      objavljenu u pariskom listu <em>Revue Du Cinéma</em>
      .<br />- Oskar Davičo i Đorđe Kostić rade seriju crteža. Aleksandar Vučo i
      Dušan Matić prave asamblaž <em>Urnebesni kliker</em>, a zajedno sa Lulom
      Vučo kolaž <em>Une atmosphère du printemps et de jeunesse</em>. Vane Bor
      radi seriju fotomontaža. Ljubiša Jocić izdaje prvu knjigu poezije San ili
      biljka.
      <br />
      <br />
      <div>1931.</div>
      Časopis <em>Nadrealizam danas i ovde</em> izlazi u Beogradu, a saradnici
      su: A. Vučo, O. Davičo, Dj. Jovanović, Vane Bor, R. Živanović Noe, M.
      Ristić, D. Matić, Dj. Kostić, K. Popović, P. Popović, a iz Francuske: S.
      Dali, A. Breton, R. Sar (Char), R. Krevel (Crevel), P. Elijar (Eluard), M.
      Ernst, I. Tangi (nj. Tangunj), T. Cara (Tzara). Likovne priloge su
      objavili: Radojica Živanovic Noe, Dušan Matić, Salvador Dali, Maks Ernst
      (Max Ernst), Iv Tangi (njves Tangunj), Alberto Djakometi (Alberto
      Giacometti) i Huan Miro (Joan Mirò). <br />- Marko Ristić i Dušan Matić
      objavljuju <em>Poziciju nadrealizma</em> koju nisu potpisali svi članovi
      grupe. <br />
      - Vane Bor upoznaje u Parizu Salvadora Dalija sa kojim će ostati u
      prepisci nekoliko godina. <br />- U časopisu{" "}
      <em>La surréalisme au service de la révolution</em> (no. 3) izlazi{" "}
      <em>Pozicija nadrealizma</em> pod naslovom "
      <em>Belgrade, 23 décembre 1930</em>" koja počinje izjavom: "Tout un monde
      contre tout un monde". Potpisnici su: Davičo, Dedinac, Vane Bor, Živanović
      Noe, Jovanović, Kostić, Matić, K. Popović, P. Popović, Ristić i Aleksandar
      Vučo. <br />- Marko Ristić i Koča Popović izdaju knjigu{" "}
      <em>Nacrt za jednu fenomenologiju iracionalnog</em>, a Petar Popović poemu{" "}
      <em>Neću, testera stvarnosti</em> sa fotomontažom. <br />- Počinju
      nesporazumi između nadrealista i predstavnika socijalne literature,
      odnosno između redakcija časopisa <em>Nadrealizam danas i ovde</em> i{" "}
      <em>Stožera</em>. <br />
      - Marko Ristić kratko stanuje u kući francuskih nadrealista na Monparnasu,
      14 Rue de Château.
      <br />
      <br />
      <div>1932.</div>
      - Radojica Živanović Noe priređuje izložbu nadrealističkih slika sa
      nadrealističkim izdanjima u Umetničkom paviljonu "Cvijeta Zuzorić" u
      Beogradu. <br />- Marko Ristić i Vane Bor objavljuju knjigu{" "}
      <em>Anti-zid</em>, a Aleksandar Vučo knjige poezije <em>Humor zaspalo</em>
      , <em>Nemenikuće</em>, <em>Ćirilo i Metodije</em>. Dušan Matić, Oskar
      Davičo i Djordje Kostić izdaju knjigu{" "}
      <em>Položaj nadrealizma u društvenom procesu</em>, a Boško Tokin{" "}
      <em>Terazije</em>, roman sa fotomontažom. <br />- Posle trećeg broja
      prestaje da izlazi časopis <em>Nadrealizam danas i ovde</em>. <br />
      - Oskar Davičo je uhapšen u Bihaću, a Đorđe Jovanović i Koča Popović u
      Beogradu. Moni de Buli se seli u Pariz.
      <br />
      <br />
      <div>1933.</div>- Zbog revolucionarnih i nadrealističkih aktivnosti Oskar
      Davičo, Đorđe Jovanović i Koča Popović odlaze u zatvor u Sremsku
      Mitrovicu, a neki od njih će tu ostati par godina. Rene Krevel (René
      Crevel) tim povodom u tekstu "
      <em>Des surréalistes jougoslaves sont au bagne</em>" (Le surréalisme au
      service de la révolution, no. 6), detaljno govori o njihovom hapšenju i
      zatvaranju bez suđenja upozoravajući na pojavu nacizma i fašizma u Evropi.
      Prilozi Marka Ristića "<em>L’humour est–il une, attitude morale</em>" i
      Zdenka Rajha (Zdenko Reich) "<em>Préface à une étude sur la métaphore</em>
      " objavljeni su u istom broju časopisa{" "}
      <em>Le surréalisme au service de la révolution</em>. - Privatno pismo Vana
      Bora upućeno Salvadoru Daliju od 31. decembra 1932. iz Beograda objavljeno
      je takođe u tom šestom broju nadrealističkog časopisa. <br />- U Beogradu
      izlazi iz štampe knjiga za decu sa fotomontažama Aleksandra Vuča i Dušana
      Matića, <em>Podvizi družine "Pet petlića"</em>.<br />
      <br />
      <div>1934.</div>- U novom beogradskom časopisu <em>Danas</em> (urednici
      Milan Bogdanović i Miroslav Krleža), među saradnicima se nalazi i deo
      nadrealističke grupe: Marko Ristić, Koča Popović i Vane Bor. <br />- Milan
      Dedinac je održao predavanje{" "}
      <em>Šta je nadrealizam i šta hoće nadrealisti</em>. <br />- Ljubiša Jocić
      objavljuje knjigu pesama <em>Ljubav i sloboda</em>.<br />- Radojica
      Živanović Noe prelazi u novoosnovanu umetnicku grupu <em>Život</em>.<br />
      <div>1935.</div>- Vane Bor pravi seriju fotografija{" "}
      <em>Jedan minut pre zločina</em>. <br />- Aleksandar Vučo i Dušan Matić
      izdaju poemu <em>Marija Rucara</em>. <br />- Održana je prva{" "}
      <em>Medjunarodna izložba nadrealizma</em> u Kopenhagenu, a zatim će slične
      izložbe biti priredjene u Londonu (1936), Parizu (1938, 1947, 1960),
      Meksiku (1940), Njujorku (1942), Pragu (1948) itd.
      <br />
      <br />
      <div>1936.</div>- Osnovan je časopis <em>Naša stvarnost</em> u Beogradu, a
      urednik je Aleksandar Vučo (do 1939). Među saradnicima su R. Živanović Noe
      i Đ. Jovanović. <br />
      - Vane Bor je postao član Filmske kulturne zadruge osnovane u Zemunu,
      zajedno sa kompozitorom Josipom Slavenskim i istoričarem umetnosti Jovanom
      Đorđevićem. U saradnji sa američkim producentom Ester Wonsonom (Esther
      Johnson) on snima film o Beogradu (nije sačuvan). <br />- Đorđe Kostić
      prisustvuje performansu Salvadora Dalija na otvaranju{" "}
      <em>Međunarodne izložbe nadrealizma</em> u Londonu.
      <br />
      <br />
      <div>1937.</div>- Marko Ristić objavljuje esej <em>Pablo Pikaso</em> u
      novoosnovanom zagrebačkom časopisu <em>Ars</em> (br. 2), a Milan Dedinac
      knjigu poezije <em>Jedan čovek na prozoru</em>. <br />
      - Marko i Ševa Ristić borave na Svetskoj izložbi u Parizu i posećuju
      Dalija, Tiriona, Bretona i Galeriju Gradiva. <br />
      - Koča Popović učestvuje u borbama internacionalnih brigada u Španiji.
      <br />
      <br />
      <div>1938.</div>- <em>Turpituda, "paranojačko-didaktična rapsodija"</em>{" "}
      Marka Ristića, sa crtežima Krste Hegedušića, objavljena u Zagrebu i odmah
      zaplenjena i uništena na osnovu Zakona o zaštiti javne bezbednosti i
      poretka u državi. <br />- U pariskom časopisu <em>Minotaure</em> (no. 3–4)
      saradjuje Marko Ristić u Enljuête Dictionnaire abrégé du surréalisme.{" "}
      <br />- Održana je <em>Međunarodna izložba nadrealizma</em> u Parizu na
      kojoj su bila dela sedamdesetoro umetnika iz četrnaest zemalja: Engleske,
      Nemačke, Austrije, Belgije, Danske, Španije, Amerike, Francuske, Italije,
      Rumunije, Švedske, Švajcarske, Čehoslovačke i Japana.
      <br />
      <br />
      <div>1939.</div>- Marko Ristić pravi <em>Asamblaž</em> koji je sastavni
      deo zaostavštine umetnosti nadrealizma u Lagatu Marka Ristića, poklon
      Marka, Ševe i Mare Ristić Muzeju savremene umetnosti u Beogradu od 1993.
      godine.
      <br />
      <br />
      <br />
      <br />
    </Wrapper>
  );
};

export default Avangarda;
